import * as React from "react"

export default function useDebouncedString (searchStr: string, delay: number) {

  const [debouncedSearchStr, setDebouncedSearchStr] = React.useState(searchStr)
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchStr(searchStr)
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  }, [searchStr])

  return debouncedSearchStr
}